"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _commonCta = require("@mmc/common-cta");
var _reactLazyLoadImageComponent = require("react-lazy-load-image-component");
var _arrowLeft = _interopRequireDefault(require("../icons/arrowLeft.svg"));
var _arrowLeftDark = _interopRequireDefault(require("../icons/arrowLeftDark.svg"));
var _selectMenu = _interopRequireDefault(require("./select-menu"));
var _types = require("./types");
var _dropdownMenu = _interopRequireDefault(require("./dropdown-menu"));
var _commonHorizontalList = _interopRequireDefault(require("../styles/common-horizontal-list.css"));
var _baseHorizontalList = _interopRequireWildcard(require("./base-horizontal-list"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ie12 = 12;
var ie11 = 11;
var ieVersion = -1;
var isFirefox = false;
var isSafari = false;
var getCTAData = function getCTAData(item) {
  var priority = 'trivial';
  if (! /*#__PURE__*/_react["default"].isValidElement(item) && typeof item === 'object' && item !== null) {
    return {
      priority: priority,
      label: item.label,
      url: item.url,
      roleTab: true
    };
  }
  return {
    priority: priority,
    label: item,
    roleTab: true
  };
};
var PaymentHorizontalList = /*#__PURE__*/function (_BaseHorizontalList) {
  (0, _inheritsLoose2["default"])(PaymentHorizontalList, _BaseHorizontalList);
  // All components need a resourceType in order for AEM to be aware of its existance
  PaymentHorizontalList.resourceType = function resourceType() {
    return 'PaymentHorizontalList_1_0_0';
  };
  function PaymentHorizontalList(props) {
    var _this;
    _this = _BaseHorizontalList.call(this, props) || this;
    if (typeof window !== 'undefined' && typeof window.navigator !== 'undefined') {
      var ua = window.navigator.userAgent.toLowerCase();
      ieVersion = (0, _baseHorizontalList.checkIEVersion)();
      isFirefox = ua.indexOf('firefox') > -1;
      isSafari = ua.indexOf('safari') > -1 && ua.indexOf('chrome') === -1;
    }
    _this.state = {
      controlsDisplay: 'show',
      leftArrowDisplay: '',
      rightArrowDisplay: '',
      isScrollable: false,
      selectMenuDisplay: 'hide',
      dropdownMenuDisplay: 'hide',
      horizontalListDisplay: 'show',
      horizontalListOpacity: 'transparent',
      useRotatedControls: false
    };
    _this.isRTL = typeof window !== 'undefined' && typeof window.document !== 'undefined' && window.document.getElementsByTagName('html')[0].getAttribute('dir') === 'rtl';
    _this.listWrapper = /*#__PURE__*/_react["default"].createRef();
    _this.listWidth = 0;
    _this.handleControls = _this.handleControls.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onArrowClickBack = _this.onArrowClickBack.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onArrowClickForward = _this.onArrowClickForward.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = PaymentHorizontalList.prototype;
  _proto.render = function render() {
    var _this2 = this,
      _clsx;
    var _this$props = this.props,
      theme = _this$props.theme,
      items = _this$props.items,
      classes = _this$props.classes,
      ctaClasses = _this$props.ctaClasses,
      ctaWrapperClasses = _this$props.ctaWrapperClasses,
      tabListClasses = _this$props.tabListClasses,
      selectName = _this$props.selectName,
      activeIndex = _this$props.activeIndex,
      showSelectMenuIfScrollable = _this$props.showSelectMenuIfScrollable,
      showSelectMenuAllBreakpoints = _this$props.showSelectMenuAllBreakpoints,
      _onKeyDown = _this$props.onKeyDown,
      ariaControlsId = _this$props.ariaControlsId,
      tabClasses = _this$props.tabClasses,
      onItemClick = _this$props.onItemClick,
      arrowIsDark = _this$props.arrowIsDark,
      arrowWrapperClasses = _this$props.arrowWrapperClasses,
      spaceBetweenArrows = _this$props.spaceBetweenArrows,
      overrideCTAs = _this$props.overrideCTAs,
      showDropdownMenuIfScrollable = _this$props.showDropdownMenuIfScrollable,
      overviewText = _this$props.overviewText,
      onDropdownToggle = _this$props.onDropdownToggle,
      _this$state = this.state,
      leftArrowDisplay = _this$state.leftArrowDisplay,
      rightArrowDisplay = _this$state.rightArrowDisplay,
      controlsDisplay = _this$state.controlsDisplay,
      isScrollable = _this$state.isScrollable,
      selectMenuDisplay = _this$state.selectMenuDisplay,
      dropdownMenuDisplay = _this$state.dropdownMenuDisplay,
      horizontalListDisplay = _this$state.horizontalListDisplay,
      horizontalListOpacity = _this$state.horizontalListOpacity,
      useRotatedControls = _this$state.useRotatedControls;
    var spaceBetweenArrowsClass = spaceBetweenArrows ? 'spaceBetween' : '';
    var arrowIcon = arrowIsDark ? _arrowLeftDark["default"] : _arrowLeft["default"];
    var afterSpace = rightArrowDisplay === 'show' || !spaceBetweenArrows && leftArrowDisplay === 'show' || rightArrowDisplay === 'show' && leftArrowDisplay === 'show' ? _commonHorizontalList["default"].addSpaceAfter : '';
    var selectMenuAllBreakpoints = showSelectMenuAllBreakpoints === true;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, showSelectMenuIfScrollable && /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx2["default"])(_commonHorizontalList["default"].selectMenuParent, _commonHorizontalList["default"][selectMenuDisplay]),
      "data-selectmenuallbreakpoints": selectMenuAllBreakpoints
    }, /*#__PURE__*/_react["default"].createElement(_selectMenu["default"], {
      options: items,
      onChange: onItemClick,
      selectName: selectName,
      value: activeIndex,
      theme: theme
    })), showDropdownMenuIfScrollable && /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx2["default"])(_commonHorizontalList["default"].dropdownMenuParent, _commonHorizontalList["default"][dropdownMenuDisplay]),
      "data-selectmenuallbreakpoints": selectMenuAllBreakpoints
    }, /*#__PURE__*/_react["default"].createElement(_dropdownMenu["default"], {
      items: items,
      overviewText: overviewText,
      theme: theme,
      getCTAData: getCTAData,
      onDropdownToggle: onDropdownToggle
    })), /*#__PURE__*/_react["default"].createElement("div", {
      "data-scrollable": isScrollable,
      "data-selectmenuallbreakpoints": selectMenuAllBreakpoints,
      className: (0, _clsx2["default"])(_commonHorizontalList["default"].wrapper, classes, _commonHorizontalList["default"][horizontalListDisplay], _commonHorizontalList["default"][horizontalListOpacity], afterSpace)
    }, /*#__PURE__*/_react["default"].createElement("ul", {
      ref: this.listWrapper,
      className: (0, _clsx2["default"])(tabListClasses),
      role: "tablist",
      tabIndex: "0"
    }, items.map(function (item, index) {
      if (overrideCTAs === true) {
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: item.id || index,
          className: (0, _clsx2["default"])(tabClasses)
        }, item);
      }
      var isActive = activeIndex === index;
      var data = getCTAData(item);
      return /*#__PURE__*/_react["default"].createElement("li", {
        role: "tab",
        key: item.id || index,
        onClick: _this2.isDisabledTab(index) ? null : function () {
          return onItemClick(index);
        },
        className: (0, _clsx2["default"])(tabClasses),
        onKeyDown: function onKeyDown(e) {
          return _onKeyDown(index, e);
        },
        "aria-selected": isActive ? 'true' : 'false',
        "aria-disabled": _this2.isDisabledTab(index)
      }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
        data: data,
        theme: theme,
        classes: ctaClasses,
        spanClasses: ctaWrapperClasses
      }));
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx2["default"])(arrowWrapperClasses, _commonHorizontalList["default"].arrowWrapper, _commonHorizontalList["default"][controlsDisplay], _commonHorizontalList["default"][spaceBetweenArrowsClass], (_clsx = {}, _clsx[_commonHorizontalList["default"].rotateControls] = useRotatedControls, _clsx))
    }, /*#__PURE__*/_react["default"].createElement("button", {
      className: (0, _clsx2["default"])(_commonHorizontalList["default"].arrowLeft, _commonHorizontalList["default"][leftArrowDisplay]),
      onClick: this.onArrowClickBack,
      type: "button",
      "aria-label": "Scroll left"
    }, /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
      src: arrowIcon,
      alt: "scroll-left"
    })), /*#__PURE__*/_react["default"].createElement("button", {
      className: (0, _clsx2["default"])(_commonHorizontalList["default"].arrowRight, _commonHorizontalList["default"][rightArrowDisplay]),
      onClick: this.onArrowClickForward,
      type: "button",
      "aria-label": "Scroll right"
    }, /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
      src: arrowIcon,
      alt: "scroll-right"
    })))));
  };
  return PaymentHorizontalList;
}(_baseHorizontalList["default"]);
exports["default"] = PaymentHorizontalList;
PaymentHorizontalList.displayName = 'PaymentHorizontalList';
PaymentHorizontalList.propTypes = {
  items: _propTypes["default"].array,
  classes: _types.classesPropType,
  tabListClasses: _types.classesPropType,
  ctaClasses: _types.classesPropType,
  tabClasses: _types.classesPropType,
  disabledTabs: _propTypes["default"].array,
  arrowWrapperClasses: _types.classesPropType,
  activeIndex: _propTypes["default"].number,
  ariaControlsId: _propTypes["default"].string,
  spaceBetweenArrows: _propTypes["default"].bool,
  showSelectMenuAllBreakpoints: _propTypes["default"].bool,
  arrowIsDark: _propTypes["default"].bool,
  showSelectMenuIfScrollable: _propTypes["default"].bool,
  onKeyDown: _propTypes["default"].func,
  onDropdownToggle: _propTypes["default"].func,
  onItemClick: _propTypes["default"].func,
  showDropdownMenuIfScrollable: _propTypes["default"].bool,
  overviewText: _propTypes["default"].string,
  theme: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  ctaWrapperClasses: _types.classesPropType,
  selectName: _propTypes["default"].string,
  overrideCTAs: _propTypes["default"].bool
};
PaymentHorizontalList.defaultProps = {
  items: [],
  activeIndex: null,
  spaceBetweenArrows: false,
  showSelectMenuIfScrollable: false,
  arrowIsDark: false,
  ariaControlsId: '0',
  onDropdownToggle: function onDropdownToggle() {
    return null;
  },
  onKeyDown: function onKeyDown() {
    return null;
  },
  onItemClick: function onItemClick() {
    return null;
  },
  showDropdownMenuIfScrollable: false,
  overviewText: ''
};